import * as normalize from 'utils/normalize';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getSignature from 'utils/print/getSignature';
import getInsuranceID from 'utils/print/getInsuranceID';
import getPatientName from 'utils/print/getPatientName';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityName from 'utils/print/getFacilityName';
import getBusinessStreet from 'utils/print/getBusinessStreet';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getBusinessCityStateZip from 'utils/print/getBusinessCityStateZip';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getFacilityPhone from 'utils/print/getFacilityPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getFacilityFax from 'utils/print/getFacilityFax';
import getSignatureDate from 'utils/print/getSignatureDate';

const DeliveryTicketAOB = {
  ID: 13,
  Name: 'Assignment Of Benefits',
  Type: 'Delivery Ticket',
  Format: 'letter',
  Orientation: 'p',
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Delivery-Ticket-AOB/1.js',
      Logo: {
        x: 22,
        y: 22,
        width: 50,
        height: 20,
      },
      texts: [
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props) || getBusinessStreet(props),
          x: 151.5,
          y: 24.5,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props) || getBusinessCityStateZip(props),
          x: 151.5,
          y: 27.5,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => getFacilityPhone(props) ? `Tel: ${getFacilityPhone(props)}` : `Tel: ${getBusinessPhone(props)}`,
          x: 151.5,
          y: 30.5,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => getFacilityFax(props) ? `Fax: ${getFacilityFax(props)}` : `Fax: ${getBusinessFax(props)}`,
          x: 151.5,
          y: 33.5,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 1',
          getText: props => `1. Assignment of Medicare, Medicaid, Medicare Supplemental or other insurance benefits to ${getFacilityName(props) || getBusinessName(props)} for medical supplies furnished to me by ${getFacilityName(props) || getBusinessName(props)}`,
          x: 19,
          y: 73.5,
          width: 177,
          fontSize: 11,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 2',
          getText: props => `4. ${getFacilityName(props) || getBusinessName(props)} to obtain medical or other information necessary in order to process my claim(s), including determining eligibility and seeking reimbursement for medical supplies and/or medication(s) provided.`,
          x: 19,
          y: 112,
          width: 177,
          fontSize: 11,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 3',
          getText: props => `5. ${getFacilityName(props) || getBusinessName(props)} to contact me by telephone or mail regarding my medical supplies order.`,
          x: 19,
          y: 130.5,
          width: 177,
          fontSize: 11,
          lineHeight: 1.2,
        },
        {
          name: 'Copy 4',
          getText: props => `I request that payment of Medicare, Medicaid, Medicare Supplemental ot other insurance benefits be made on my behalf to ${getFacilityName(props) || getBusinessName(props)} for any medical supples and/or medications furnished to me by ${getFacilityName(props) || getBusinessName(props)}. I authorize any holder of medical information about me to release ${getFacilityName(props) || getBusinessName(props)}, my physician(s), caregiver, CMS, its agents and to my primary and/or other medical insurer any information needed to determine or secure eligibility information and/or reimbursement for covered services. I agree to pay all amounts that are not covered by my insurer(s) and for which I am responsible.`,
          x: 19,
          y: 182,
          width: 177,
          fontSize: 11,
          lineHeight: 1.1,
        },
      ],
      fields: [
        {
          name: 'Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 96,
          y: 155,
          width: 9,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 106,
          y: 155,
          width: 9,
          maxLength: 3,
          normalize: normalize.number,

        },
        {
          name: 'Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 116,
          y: 155,
          width: 12,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Signature',
          type: 'signature',
          getValue: getSignature,
          x: 66,
          y: 166,
          width: 60,
          height: 13,
        },
        {
          name: 'Date 1',
          type: 'text',
          getValue: props =>  getSignatureDate({ ...props, slice: [0, 2] }),
          x: 164,
          y: 170.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 2',
          type: 'text',
          getValue: props =>  getSignatureDate({ ...props, slice: [3, 5] }),
          x: 173,
          y: 170.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date 3',
          type: 'text',
          getValue: props =>  getSignatureDate({ ...props, slice: [8, 10] }),
          x: 181,
          y: 170.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Box 1',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [0, 1] }),
          x: 54,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 2',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [1, 2] }),
          x: 65,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 3',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [2, 3] }),
          x: 76,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 4',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [3, 4] }),
          x: 88,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 5',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [4, 5] }),
          x: 99,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 6',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [5, 6] }),
          x: 111,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 7',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [6, 7] }),
          x: 122,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 8',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [7, 8] }),
          x: 134,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 9',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [8, 9] }),
          x: 145,
          y: 213,
          width: 5,
        },
        {
          name: 'Box 10',
          type: 'text',
          getValue: props => getInsuranceID({ ...props, slice: [9, 10] }),
          x: 157,
          y: 213,
          width: 9,
        },
        {
          name: 'Insurer',
          type: 'text',
          getValue: getPatientName,
          x: 36,
          y: 226,
          width: 62,
        },
        {
          name: 'Policy',
          type: 'text',
          x: 117,
          y: 226,
          width: 80,
        },
        {
          name: 'Insurer Phone',
          type: 'text',
          x: 117,
          y: 231,
          width: 80,
          normalize: normalize.phone,
          format: value => (value ? value.replace('+1 ', '') : ''),
        },
        {
          name: 'Errors',
          type: 'text',
          x: 86,
          y: 240,
          width: 110,
        },
      ],
    },
  ],
};

export default DeliveryTicketAOB;



// WEBPACK FOOTER //
// ./src/config/documents/Delivery-Ticket-AOB.js